document.addEventListener("DOMContentLoaded", () => {
  // Navigate from non-link areas of a product card (price, padding, etc.)
  document.addEventListener(
    "click",
    (e) => {
      if (e.target.closest(".ir-quick-add-btn")) return;
      if (e.target.closest("a[href]")) return;
      if (e.target.closest("button, input, label, select")) return;

      const card = e.target.closest(
        "#product-grid .card-wrapper, #product-grid .product-card-wrapper, .product-grid-container .card-wrapper"
      );
      if (!card) return;

      const link =
        card.querySelector("a.ir-card-media-link[href]") ||
        card.querySelector(".card__heading a[href]");
      if (!link || !link.href) return;

      window.location.href = link.href;
    },
    true
  );

  const overlay = document.createElement("div");
  overlay.className = "ir-quick-overlay";
  document.body.appendChild(overlay);

  const SIZE_CHARTS = {
    tshirts:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/Cream_Minimalist_Simple_Size_Chart_Instagram_Post_04bdbe26-9134-4fcf-bab7-db8ce4847f65.png?v=1749458415",
    hoodies:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/Cream_Minimalist_Simple_Size_Chart_Instagram_Post_copy.png?v=1749458573",
    pants:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/regularoversizedpants.png?v=1765643380",
    tshirt4:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/tshirt4.png?v=1765643379",
    tshirt5:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/tshirt5.png?v=1765643380",
    tshirt3:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/tshirt4.png?v=1765643379",
    hoodie1:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/hoodie1.png?v=1765643394",
    boxiehoodie:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/boxiehoodie.png?v=1765643379",
    widelegpants:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/regularoversizedpants.png?v=1765643380",
    regularoversizedpants:
      "https://cdn.shopify.com/s/files/1/0583/7861/6929/files/regularoversizedpants.png?v=1765643380",
  };

  const LOW_STOCK_THRESHOLD = 5;

  const mDrawer = document.getElementById("m-drawer");
  if (mDrawer) {
    const navObserver = new MutationObserver(() => {
      const isOpen = mDrawer.getAttribute("aria-hidden") === "false";
      document.querySelectorAll(".ir-quick-add-btn").forEach((btn) => {
        btn.style.visibility = isOpen ? "hidden" : "";
        btn.style.opacity = isOpen ? "0" : "";
        btn.style.pointerEvents = isOpen ? "none" : "";
      });
    });
    navObserver.observe(mDrawer, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  }

  let selectedVariant = null;
  let selectedSizeLabel = "";
  let currentQty = 1;
  let currentProduct = null;
  let currentImages = [];
  let currentImageIndex = 0;
  let touchStartX = 0;
  let touchEndX = 0;
  let stockByVariantId = {};
  let learnedMaxByVariantId = {};

  const productCache = {};
  const stockCache = {};

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function money(cents) {
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
    } catch (e) {
      return `$${(cents / 100).toFixed(0)}`;
    }
  }

  function resolveSizeChart(url, type) {
    if (url && !url.includes("PASTE_")) return url;
    if (type && SIZE_CHARTS[type]) return SIZE_CHARTS[type];
    return "";
  }

  function getSizeFromVariant(product, variant) {
    const options = product.options || [];
    const sizeIndex = options.findIndex((option) => {
      const name = typeof option === "string" ? option : option.name;
      return String(name || "")
        .toLowerCase()
        .includes("size");
    });
    if (sizeIndex === -1) return variant.option1;
    return variant.options[sizeIndex];
  }

  function salePercent(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round(((compare - price) / compare) * 100);
  }

  function renderPriceHtml(price, compare) {
    if (compare && compare > price) {
      return `
        <span class="ir-quick-sale">${money(price)}</span>
        <span class="ir-quick-compare">${money(compare)}</span>
      `;
    }
    return `<span class="ir-quick-sale ir-quick-sale--plain">${money(price)}</span>`;
  }

  function imageFileName(url) {
    if (!url) return "PRODUCT.JPG";
    try {
      const clean = String(url).split("?")[0];
      const base = clean.split("/").pop() || "PRODUCT.JPG";
      return base.toUpperCase();
    } catch (e) {
      return "PRODUCT.JPG";
    }
  }

  function buildCrumb(product) {
    const tags = (product.tags || []).map((t) => String(t).toLowerCase());
    let gender = "";
    if (tags.some((t) => t.includes("women") || t === "womens" || t === "woman")) {
      gender = "WOMENS";
    } else if (tags.some((t) => t.includes("men") || t === "mens" || t === "man")) {
      gender = "MENS";
    }

    let type = String(product.type || "").trim();
    if (!type) {
      const title = String(product.title || "").toLowerCase();
      if (title.includes("pant") || title.includes("trouser")) type = "PANTS";
      else if (title.includes("hoodie")) type = "HOODIES";
      else type = "T-SHIRTS";
    }
    type = type.replace(/_/g, " ").toUpperCase();

    if (gender) return `/ ${gender} — ${type}`;
    return `/ ${type}`;
  }

  function renderImage() {
    const img = document.querySelector(".ir-quick-image");
    const thumb = document.querySelector(".ir-quick-thumb");
    const dots = document.querySelectorAll(".ir-gallery-dot");
    if (!currentImages.length) return;
    const src = currentImages[currentImageIndex];
    if (img) img.src = src;
    if (thumb) thumb.src = src;
    dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === currentImageIndex);
    });
  }

  function updateSizeLabel() {
    const label = document.querySelector(".ir-size-label");
    if (!label) return;
    label.textContent = selectedSizeLabel
      ? `SELECT SIZE — ${selectedSizeLabel}`
      : "SELECT SIZE";
  }

  function updateStockLine(variant) {
    const line = document.querySelector(".ir-stock-line");
    if (!line) return;
    const qty = getMaxAvailableQty(variant);
    if (
      variant &&
      variant.available &&
      qty != null &&
      qty > 0 &&
      qty <= LOW_STOCK_THRESHOLD
    ) {
      const size = selectedSizeLabel || "this size";
      line.hidden = false;
      line.textContent = `● Only ${qty} left in ${size} — selling fast`;
    } else {
      line.hidden = true;
      line.textContent = "";
    }
  }

  function getSelectedVariantObj() {
    if (!currentProduct || !selectedVariant) return null;
    return (
      currentProduct.variants.find(
        (v) => String(v.id) === String(selectedVariant)
      ) || null
    );
  }

  function getMaxAvailableQty(variant) {
    if (!variant) return null;
    const id = String(variant.id);

    if (Object.prototype.hasOwnProperty.call(learnedMaxByVariantId, id)) {
      return Math.max(0, learnedMaxByVariantId[id]);
    }

    if (Object.prototype.hasOwnProperty.call(stockByVariantId, id)) {
      const stock = stockByVariantId[id];
      if (stock == null) return null;
      return Math.max(0, Number(stock) || 0);
    }

    if (typeof variant.inventory_quantity === "number") {
      return Math.max(0, variant.inventory_quantity);
    }

    return null;
  }

  function loadStockMap(handle) {
    if (stockCache[handle]) return stockCache[handle];
    stockCache[handle] = fetch(`/products/${handle}?view=ir-stock`)
      .then((r) => {
        if (!r.ok) throw new Error("stock fetch failed");
        return r.json();
      })
      .then((data) => {
        const map = {};
        (data.variants || []).forEach((v) => {
          map[String(v.id)] = v.inventory_quantity;
        });
        return map;
      })
      .catch(() => ({}));
    return stockCache[handle];
  }

  function parseAvailableFromError(payload) {
    const text = String(
      (payload && (payload.description || payload.message || payload)) || ""
    );
    const match = text.match(/(\d+)\s*(?:left|available|in stock|of this)/i);
    if (match) return Math.max(0, Number(match[1]));
    const onlyAdd = text.match(/only add\s+(\d+)/i);
    if (onlyAdd) return Math.max(0, Number(onlyAdd[1]));
    return null;
  }

  function clampQtyToStock(showMessage) {
    const variant = getSelectedVariantObj();
    const max = getMaxAvailableQty(variant);
    const msg = document.querySelector(".ir-message");
    const plusBtn = document.querySelector(".ir-qty-plus");

    if (max != null) {
      if (currentQty > max) {
        currentQty = Math.max(1, max);
        if (showMessage && msg) {
          msg.textContent =
            max <= 0
              ? "Not enough quantity."
              : `Not enough quantity. Only ${max} available.`;
        }
      }
      if (plusBtn) {
        plusBtn.disabled = currentQty >= max;
        plusBtn.setAttribute("aria-disabled", currentQty >= max ? "true" : "false");
      }
    } else if (plusBtn) {
      plusBtn.disabled = false;
      plusBtn.removeAttribute("aria-disabled");
    }

    updateQtyUI();
  }

  function isQuantityError(payload) {
    const text = String(
      (payload && (payload.description || payload.message || payload)) || ""
    ).toLowerCase();
    return (
      text.includes("quantity") ||
      text.includes("inventory") ||
      text.includes("stock") ||
      text.includes("sold out") ||
      text.includes("not enough") ||
      text.includes("only add") ||
      text.includes("don't have enough") ||
      text.includes("do not have enough") ||
      text.includes("cannot add") ||
      text.includes("can't add")
    );
  }

  function updatePriceUI(variant) {
    const priceEl = document.querySelector(".ir-quick-price");
    const addPrice = document.querySelector(".ir-add-final-price");
    if (!variant) return;
    const price = variant.price;
    const compare = variant.compare_at_price;
    if (priceEl) priceEl.innerHTML = renderPriceHtml(price, compare);
    if (addPrice) addPrice.textContent = `${money(price)} →`;
  }

  function updateQtyUI() {
    const el = document.querySelector(".ir-qty-value");
    if (el) el.textContent = String(currentQty);
  }

  function openQuickAdd(handle, sizeChartUrl, sizeChartType, productUrl) {
    const productPromise = productCache[handle]
      ? productCache[handle]
      : fetch(`/products/${handle}.js`).then((r) => {
          if (!r.ok) throw new Error("Product fetch failed");
          return r.json();
        });

    productCache[handle] = productPromise;

    Promise.all([productPromise, loadStockMap(handle)])
      .then(([product, stockMap]) => {
        currentProduct = product;
        stockByVariantId = stockMap || {};
        selectedVariant = null;
        selectedSizeLabel = "";
        currentQty = 1;
        currentImages = (product.images || []).slice();
        if (!currentImages.length && product.featured_image) {
          currentImages = [product.featured_image];
        }
        currentImageIndex = 0;

        const uniqueSizes = [];
        product.variants.forEach((variant) => {
          const size = getSizeFromVariant(product, variant);
          const existing = uniqueSizes.find((item) => item.size === size);
          if (!existing) {
            uniqueSizes.push({
              size,
              id: variant.id,
              available: variant.available,
              variant,
            });
          } else if (variant.available) {
            existing.id = variant.id;
            existing.available = true;
            existing.variant = variant;
          }
        });

        const sizeOptions = uniqueSizes
          .map((item) => {
            const disabled = !item.available;
            return `
              <button
                type="button"
                class="ir-size-btn${disabled ? " disabled" : ""}"
                data-variant-id="${item.id}"
                data-size="${escapeHtml(item.size)}"
                data-available="${item.available}"
                ${disabled ? "disabled" : ""}>
                ${escapeHtml(item.size)}
              </button>
            `;
          })
          .join("");

        const dots = currentImages
          .map(
            (_, index) =>
              `<button type="button" class="ir-gallery-dot ${
                index === 0 ? "active" : ""
              }" data-index="${index}" aria-label="Image ${index + 1}"></button>`
          )
          .join("");

        const resolvedChart = resolveSizeChart(sizeChartUrl, sizeChartType);
        const viewUrl = productUrl || product.url;
        const price = product.price;
        const compare = product.compare_at_price;
        const pct = salePercent(price, compare);
        const onSale = pct > 0;
        const firstImage = currentImages[0] || "";
        const crumb = buildCrumb(product);

        overlay.innerHTML = `
          <div class="ir-quick-modal" role="dialog" aria-modal="true" aria-label="${escapeHtml(
            product.title
          )}">
            <div class="ir-quick-sheet-handle" aria-hidden="true"></div>
            <div class="ir-quick-sheet-head">
              <p class="ir-quick-sheet-label">/ QUICK ADD</p>
              <button type="button" class="ir-quick-close" aria-label="Close">
                <svg viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M4 4l12 12M16 4L4 16"></path>
                </svg>
              </button>
            </div>

            <button type="button" class="ir-quick-close ir-quick-close--desktop" aria-label="Close">
              <svg viewBox="0 0 20 20" aria-hidden="true">
                <path d="M4 4l12 12M16 4L4 16"></path>
              </svg>
            </button>

            <div class="ir-quick-gallery">
              <button type="button" class="ir-gallery-arrow ir-gallery-prev" aria-label="Previous image"${
                currentImages.length < 2 ? " hidden" : ""
              }>‹</button>

              <div class="ir-quick-image-wrap">
                ${
                  onSale
                    ? `<span class="ir-quick-sale-tag">SALE — ${pct}% OFF</span>`
                    : ""
                }
                <img class="ir-quick-image" src="${firstImage}" alt="${escapeHtml(
                  product.title
                )}">
                <div class="ir-gallery-dots">${dots}</div>
              </div>

              <button type="button" class="ir-gallery-arrow ir-gallery-next" aria-label="Next image"${
                currentImages.length < 2 ? " hidden" : ""
              }>›</button>
            </div>

            <div class="ir-quick-info">
              <div class="ir-quick-product-row">
                <div class="ir-quick-thumb-wrap">
                  ${onSale ? `<span class="ir-quick-thumb-sale">SALE</span>` : ""}
                  <img class="ir-quick-thumb" src="${firstImage}" alt="">
                </div>
                <div class="ir-quick-product-copy">
                  <p class="ir-quick-crumb">${escapeHtml(crumb)}</p>
                  <h2 class="ir-quick-title">${escapeHtml(product.title)}</h2>
                  <div class="ir-quick-price">${renderPriceHtml(price, compare)}</div>
                </div>
              </div>

              <div class="ir-size-header">
                <span class="ir-size-label">SELECT SIZE</span>
                <button type="button" class="ir-size-chart ir-size-chart-trigger">+ SIZE GUIDE</button>
              </div>

              <div class="ir-size-row">
                ${sizeOptions || "<p class='ir-message'>No sizes available.</p>"}
              </div>

              <p class="ir-stock-line" hidden></p>

              <div class="ir-quick-actions">
                <div class="ir-qty" aria-label="Quantity">
                  <button type="button" class="ir-qty-minus" aria-label="Decrease quantity">−</button>
                  <span class="ir-qty-value">1</span>
                  <button type="button" class="ir-qty-plus" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="ir-add-final">
                  <span class="ir-add-final-label">ADD TO CART</span>
                  <span class="ir-add-final-price">${money(price)} →</span>
                </button>
              </div>

              <p class="ir-message" aria-live="polite"></p>
              <a class="ir-view-details" href="${viewUrl}">VIEW FULL PRODUCT</a>
            </div>
          </div>
        `;

        overlay.dataset.sizeChartUrl = resolvedChart;
        overlay.dataset.sizeChartType = sizeChartType || "";
        overlay.classList.add("active");
        document.body.style.overflow = "hidden";
        document.body.classList.add("ir-quick-open");
      })
      .catch((err) => {
        console.error("Quick add product fetch failed", err);
        window.location.href = productUrl || `/products/${handle}`;
      });
  }

  function closeQuickAdd() {
    const chartPopup = document.querySelector(".ir-size-chart-popup");
    if (chartPopup) chartPopup.remove();
    overlay.classList.remove("active");
    overlay.innerHTML = "";
    overlay.dataset.sizeChartUrl = "";
    overlay.dataset.sizeChartType = "";
    selectedVariant = null;
    selectedSizeLabel = "";
    currentQty = 1;
    currentProduct = null;
    currentImages = [];
    currentImageIndex = 0;
    stockByVariantId = {};
    document.body.style.overflow = "";
    document.body.classList.remove("ir-quick-open");
  }

  function prefetch(handle) {
    if (!handle || productCache[handle]) return;
    productCache[handle] = fetch(`/products/${handle}.js`).then((r) => r.json());
  }

  function quickAddTrigger(target) {
    return (
      target.closest(".ir-quick-add-btn") ||
      target.closest("[data-ir-look-atc]") ||
      target.closest("[data-ir-quick-add]")
    );
  }

  document.addEventListener("mouseover", (e) => {
    const btn = quickAddTrigger(e.target);
    if (btn) prefetch(btn.dataset.productHandle);
  });

  document.addEventListener(
    "touchstart",
    (e) => {
      const btn = quickAddTrigger(e.target);
      if (btn) prefetch(btn.dataset.productHandle);
    },
    { passive: true }
  );

  document.addEventListener(
    "click",
    (e) => {
      const quickBtn = quickAddTrigger(e.target);
      if (quickBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (quickBtn.disabled) return;
        openQuickAdd(
          quickBtn.dataset.productHandle,
          quickBtn.dataset.sizeChart,
          quickBtn.dataset.sizeChartType,
          quickBtn.dataset.productUrl
        );
        return;
      }

      if (!overlay.classList.contains("active")) return;

      if (e.target.closest(".ir-quick-close")) {
        closeQuickAdd();
        return;
      }

      if (e.target === overlay) {
        closeQuickAdd();
        return;
      }

      if (e.target.closest(".ir-gallery-next")) {
        if (!currentImages.length) return;
        currentImageIndex = (currentImageIndex + 1) % currentImages.length;
        renderImage();
        return;
      }

      if (e.target.closest(".ir-gallery-prev")) {
        if (!currentImages.length) return;
        currentImageIndex =
          (currentImageIndex - 1 + currentImages.length) % currentImages.length;
        renderImage();
        return;
      }

      const dot = e.target.closest(".ir-gallery-dot");
      if (dot && dot.dataset.index != null) {
        currentImageIndex = Number(dot.dataset.index);
        renderImage();
        return;
      }

      if (e.target.closest(".ir-qty-minus")) {
        currentQty = Math.max(1, currentQty - 1);
        const msg = document.querySelector(".ir-message");
        if (msg) msg.textContent = "";
        clampQtyToStock(false);
        return;
      }

      if (e.target.closest(".ir-qty-plus")) {
        const variant = getSelectedVariantObj();
        const max = getMaxAvailableQty(variant);
        const msg = document.querySelector(".ir-message");

        if (!selectedVariant) {
          if (msg) msg.textContent = "Please select a size.";
          return;
        }

        if (max != null && currentQty >= max) {
          currentQty = max;
          updateQtyUI();
          if (msg) {
            msg.textContent =
              max <= 0
                ? "Not enough quantity."
                : `Not enough quantity. Only ${max} available.`;
          }
          clampQtyToStock(false);
          return;
        }

        currentQty += 1;
        if (msg) msg.textContent = "";
        clampQtyToStock(true);
        return;
      }

      const sizeBtn = e.target.closest(".ir-size-btn");
      if (sizeBtn && sizeBtn.dataset.available === "true") {
        document
          .querySelectorAll(".ir-size-btn")
          .forEach((btn) => btn.classList.remove("active"));
        sizeBtn.classList.add("active");
        selectedVariant = sizeBtn.dataset.variantId;
        selectedSizeLabel = sizeBtn.dataset.size || sizeBtn.textContent.trim();
        updateSizeLabel();
        const msg = document.querySelector(".ir-message");
        if (msg) msg.textContent = "";
        currentQty = 1;
        if (currentProduct) {
          const variant = currentProduct.variants.find(
            (v) => String(v.id) === String(selectedVariant)
          );
          if (variant) {
            updatePriceUI(variant);
            updateStockLine(variant);
          }
        }
        clampQtyToStock(false);
        return;
      }

      const addBtn = e.target.closest(".ir-add-final");
      if (addBtn) {
        const msg = document.querySelector(".ir-message");
        if (!selectedVariant) {
          if (msg) msg.textContent = "Please select a size.";
          return;
        }

        const variant = getSelectedVariantObj();
        const max = getMaxAvailableQty(variant);
        if (max != null && currentQty > max) {
          currentQty = Math.max(1, max);
          clampQtyToStock(false);
          if (msg) {
            msg.textContent =
              max <= 0
                ? "Not enough quantity."
                : `Not enough quantity. Only ${max} available.`;
          }
          return;
        }

        const label = addBtn.querySelector(".ir-add-final-label");
        addBtn.disabled = true;
        if (label) label.textContent = "ADDING...";

        const formData = new FormData();
        formData.append("id", selectedVariant);
        formData.append("quantity", String(currentQty));
        formData.append("sections", "cart-drawer,cart-icon-bubble");
        formData.append("sections_url", window.location.pathname);

        const cartAddUrl =
          (window.routes && window.routes.cart_add_url) || "/cart/add";

        fetch(cartAddUrl, {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        })
          .then(async (res) => {
            const response = await res.json();
            if (!res.ok || response.status) {
              const err = new Error(
                response.description || response.message || "Add to cart failed"
              );
              err.payload = response;
              err.status = res.status;
              throw err;
            }
            return response;
          })
          .then((response) => {
            if (label) label.textContent = "ADDED";
            if (msg) msg.textContent = "";

            if (window.IRMetaPixel && typeof window.IRMetaPixel.trackAddToCart === "function") {
              window.IRMetaPixel.trackAddToCart(response);
            }

            const drawer = document.querySelector("cart-drawer");
            if (drawer && typeof drawer.renderContents === "function" && response.sections) {
              closeQuickAdd();
              drawer.renderContents(response);
            } else {
              fetch("/cart.js")
                .then((r) => r.json())
                .then((cart) => {
                  document
                    .querySelectorAll(
                      ".cart-count-bubble span[aria-hidden], .cart-count-bubble span:not(.visually-hidden), .cart-count"
                    )
                    .forEach((el) => {
                      el.textContent = cart.item_count;
                    });
                });
              setTimeout(closeQuickAdd, 500);
            }
          })
          .catch((err) => {
            console.error(err);
            addBtn.disabled = false;
            if (label) label.textContent = "ADD TO CART";
            const payload = err && err.payload ? err.payload : err;
            if (isQuantityError(payload) || isQuantityError(err)) {
              const parsed = parseAvailableFromError(payload);
              const fallbackMax = Math.max(0, currentQty - 1);
              const available =
                parsed != null
                  ? parsed
                  : getMaxAvailableQty(getSelectedVariantObj()) != null
                    ? getMaxAvailableQty(getSelectedVariantObj())
                    : fallbackMax;
              learnedMaxByVariantId[String(selectedVariant)] = available;
              if (msg) {
                msg.textContent =
                  available > 0
                    ? `Not enough quantity. Only ${available} available.`
                    : "Not enough quantity.";
              }
              currentQty = Math.max(1, Math.min(currentQty, Math.max(1, available)));
              if (available <= 0) currentQty = 1;
              clampQtyToStock(false);
            } else if (msg) {
              msg.textContent = "Something went wrong. Please try again.";
            }
          });

        return;
      }

      if (e.target.closest(".ir-size-chart-trigger")) {
        e.preventDefault();
        const existing = document.querySelector(".ir-size-chart-popup");
        if (existing) existing.remove();

        const chartUrl = resolveSizeChart(
          overlay.dataset.sizeChartUrl,
          overlay.dataset.sizeChartType
        );

        const popup = document.createElement("div");
        popup.className = "ir-size-chart-popup";

        if (chartUrl) {
          popup.innerHTML = `
            <div class="ir-size-chart-popup-inner">
              <button type="button" class="ir-size-chart-popup-close" aria-label="Close size guide">
                <svg viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M4 4l12 12M16 4L4 16"></path>
                </svg>
              </button>
              <img src="${chartUrl}" alt="Size guide">
            </div>
          `;
        } else {
          popup.innerHTML = `
            <div class="ir-size-chart-popup-inner ir-size-chart-popup-inner--fallback">
              <button type="button" class="ir-size-chart-popup-close" aria-label="Close size guide">
                <svg viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M4 4l12 12M16 4L4 16"></path>
                </svg>
              </button>
              <h3 class="ir-size-chart-title">Size guide</h3>
              <p>Size guide is not available for this product yet.</p>
            </div>
          `;
        }

        document.body.appendChild(popup);
        return;
      }

      if (
        e.target.closest(".ir-size-chart-popup-close") ||
        e.target.classList.contains("ir-size-chart-popup")
      ) {
        const popup = document.querySelector(".ir-size-chart-popup");
        if (popup) popup.remove();
      }
    },
    true
  );

  document.addEventListener(
    "touchstart",
    (e) => {
      if (!e.target.closest(".ir-quick-gallery")) return;
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchend",
    (e) => {
      if (!e.target.closest(".ir-quick-gallery")) return;
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < 40 || !currentImages.length) return;
      if (diff > 0) {
        currentImageIndex = (currentImageIndex + 1) % currentImages.length;
      } else {
        currentImageIndex =
          (currentImageIndex - 1 + currentImages.length) % currentImages.length;
      }
      renderImage();
    },
    { passive: true }
  );

  document.addEventListener("keydown", (e) => {
    if (!overlay.classList.contains("active")) return;

    if (e.key === "Escape") {
      const popup = document.querySelector(".ir-size-chart-popup");
      if (popup) {
        popup.remove();
      } else {
        closeQuickAdd();
      }
      return;
    }

    if (e.key === "ArrowRight" && currentImages.length > 1) {
      currentImageIndex = (currentImageIndex + 1) % currentImages.length;
      renderImage();
    }
    if (e.key === "ArrowLeft" && currentImages.length > 1) {
      currentImageIndex =
        (currentImageIndex - 1 + currentImages.length) % currentImages.length;
      renderImage();
    }
  });
});
